<!-- SyntheticTransactionsSection.vue -->
<template>
  <div 
    v-if="configType === 'collectorconfig' && !isGeneralFileUpload" 
    class="space-y-6 glass-panel dark:text-bg-gray"
  >
    <h2 class="font-semibold mb-4 text-gray-800 dark:text-gray-200 capitalize">
      Synthetic Transactions
    </h2>
    
    <div class="grid grid-cols-2 gap-6">
      <div>
        <div class="relative group flex space-x-3">
          <h1 class="block text-sm font-medium text-gray-700 dark:text-white">Synthetic Transactions</h1>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info">
            <circle cx="12" cy="12" r="10"/>
            <path d="M12 16v-4"/>
            <path d="M12 8h.01"/>
          </svg>
          <div class="absolute bottom-full bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-900 text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none whitespace-nowrap z-10">
            Collects network service availability and measures response time using TCP, or HTTP.
          </div>
        </div>
        <div class="mt-1 max-h-80 overflow-auto z-20">
          <ul class="w-full bg-gray-200 dark:bg-gray-700 shadow-lg rounded transition-all duration-300 ease-in-out transform">
            <li 
              v-for="net in transactions"
              :key="net.id || net.tempId"
              :class="[
                'px-4 py-1 font-medium cursor-pointer',
                'dark:hover:bg-gray-800 hover:bg-gray-300',
                net.pending ? 'border-l-4 border-yellow-500 dark:border-yellow-400' : ''
              ]"
              @click="$emit('edit', net.id || net.tempId)"
            >
              <div class="flex justify-between inline-block align-middle px-4 py-2">
                <span class="shadow-sm text-sm font-medium dark:text-gray-50">
                  {{ net.name }} | {{ net.protocol }}
                </span>
                <div v-if="net.id" class="relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in z-50">
                  <input
                    type="checkbox" 
                    :id="`enabled-${net.id}`" 
                    :checked="net.enabled"
                    @change="$emit('toggle', net.id)"
                    @click.stop
                    :disabled="!metricsEnabled"
                    class="absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer peer checked:right-0 checked:bg-blue-600 transition-all duration-300 disabled:cursor-not-allowed"
                  />
                  <label 
                    :for="`enabled-${net.id}`"
                    @click.stop
                    class="block overflow-hidden h-6 rounded-full bg-gray-300 peer-checked:bg-blue-500 cursor-pointer"
                  ></label>
                </div>
                <div v-if="!net.id">
                  <button
                    @click="$emit('remove', net)"
                    @click.stop
                    type="button"
                    id="remove_transaction"
                    class="flex btn items-center gap-2 text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" 
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke-width="2" 
                        stroke="currentColor" 
                        class="w-4 h-4">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Remove
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      
      <div class="flex justify-end items-center">
        <button 
          v-if="canAdd"
          class="btn border border-transparent disabled:cursor-not-allowed rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          type="button"
          id="new_transaction"
          :disabled="!metricsEnabled"
          @click="$emit('add-new')"
        >
          Add New Synthetic Transaction
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  transactions: {
    type: Array,
    required: true
  },
  configType: {
    type: String,
    required: true
  },
  isGeneralFileUpload: {
    type: Boolean,
    default: false
  },
  metricsEnabled: {
    type: Boolean,
    default: true
  },
  canAdd: {
    type: Boolean,
    default: false
  }
})

defineEmits(['edit', 'toggle', 'remove', 'add-new'])
</script>